import { useNavigate } from "react-router-dom";

import { useOnboardingPrime } from "../api/onboarding";

const STARTER_TICKERS = ["AAPL", "NVDA", "MSFT", "TSLA", "AMD"];

/** Full-screen welcome shown to brand-new users on first Dashboard load.
 *  On Continue: synchronously runs an LLM analysis for NVDA, then routes to
 *  /s/NVDA so the user lands on a populated SymbolDetail card. */
export default function OnboardingOverlay() {
  const navigate = useNavigate();
  const prime = useOnboardingPrime();

  function start() {
    prime.mutate(undefined, {
      onSuccess: (data) => {
        const target = data.primed_symbol ?? "NVDA";
        navigate(`/s/${target}`);
      },
    });
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="onboarding-title"
    >
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-2xl">
        <h2
          id="onboarding-title"
          className="text-xl font-semibold tracking-tight text-slate-100"
        >
          Welcome to stux.
        </h2>
        <p className="mt-3 text-sm text-slate-300">
          We've added 5 starter tickers to your watchlist —
          {" "}
          {STARTER_TICKERS.map((t, i) => (
            <span key={t}>
              <span className="font-medium text-slate-100">{t}</span>
              {i < STARTER_TICKERS.length - 1 ? ", " : ""}
            </span>
          ))}
          {" "}— so you have something to look at right away.
        </p>
        <p className="mt-3 text-sm text-slate-400">
          Your first AI analysis is generating now (this takes about 10 seconds).
          When it's done, we'll drop you on the NVDA detail page so you can see
          what the daily output looks like.
        </p>

        {prime.isError && (
          <p className="mt-3 text-xs text-rose-300">
            Failed to start: {prime.error.message}. You can dismiss this and try later.
          </p>
        )}

        <div className="mt-5 flex justify-end">
          <button
            onClick={start}
            disabled={prime.isPending}
            className="rounded-lg bg-sky-500 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-sky-400 active:bg-sky-600 disabled:opacity-50"
          >
            {prime.isPending ? "Generating analysis…" : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
}
